import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ky, { HTTPError } from 'ky';
import styled from 'styled-components';
import { Grid, Button, TextField, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { authLogin, setLatest } from '../redux/workBackendSlice';
import { setTokensToCookie } from '../general';
import { apiURL } from './DigimagiProvider';

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
`
const ContainerGrid = styled(Grid)`
  height: inherit;
  width: inherit;
`;
const FormItemGrid = styled(Grid)`
  width: min(80vw, 320px);
`
const UserNameTextField = styled(TextField)`
  width: 100%;
`;
const PlainLink = styled(Link)`
  text-decoration: none;
`

type SignInSceneProps = {
  setRedirected: (value: boolean) => void;
}
const SignInScene: React.FC<SignInSceneProps> = ({ setRedirected }) => {
  const dispatch = useDispatch();
  // const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const close = () => {
    // setEmail('');
    setName('');
    setPassword('');
    setErrorMessage('');
    setRedirected(false);
  }
  const signInExe = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    try {
      const loginData = {
        username: name,
        password: password
      };
      const login = await ky.post(apiURL + 'login', { json: loginData }).json() as any;
      console.log(login)
      setTokensToCookie(login.data);
      dispatch(authLogin(true));
      dispatch(setLatest(false));
      close();
    } catch (err) {
      if (err instanceof HTTPError) console.log(err.response);
      else console.log(err);
      setErrorMessage('ユーザ名かパスワードが間違っています');
    }
  }

  return (
    <Wrapper>
      <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
        <Grid item>
          <form onSubmit={signInExe} autoComplete="off">
            <ContainerGrid container justifyContent="center" alignItems="center" direction="column" spacing={2}>
              {/* <FormItemGrid item>
                <UserNameTextField label="メールアドレス" defaultValue={email} variant="outlined" required
                  onChange={(e) => setEmail(e.target.value)} />
              </FormItemGrid> */}
              <FormItemGrid item>
                <UserNameTextField label="ユーザ名" defaultValue={name} variant="outlined" required
                  onChange={(e) => setName(e.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <UserNameTextField label="パスワード" defaultValue={password} variant="outlined" required type="password"
                  onChange={(ev) => setPassword(ev.target.value)} />
              </FormItemGrid>
              <FormItemGrid item>
                <Typography variant="caption" color="error" gutterBottom>{ errorMessage }</Typography>
              </FormItemGrid>
              <Grid item>
                <Button color="primary" type="submit" disabled={name === '' || password === ''}>ログインする</Button>
              </Grid>
            </ContainerGrid>
          </form>
        </Grid>
        <Grid item>
          <Typography variant="caption">または</Typography>
          <PlainLink to="/signup"><Button color="primary">新しいアカウントを作成する</Button></PlainLink>
        </Grid>
        <Grid item>
          <Button color="secondary" onClick={close}>
            キャンセル
          </Button>
        </Grid>
      </ContainerGrid>
    </Wrapper>
  );
}

export default SignInScene;
